export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 3.5a8 8 0 110 16 8 8 0 010-16zm-1.2 9.17l-1.793-2.09-1.214 1.04 2.4 2.8.06.063a.801.801 0 001.154-.063l4.8-5.6-1.214-1.04-4.193 4.89z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};